import type { FC } from "react";

import { MoveSiteModal } from "src/app/features/Site/components/buttons/MoveSiteModal";
import { SiteGroupBatchUpdateDrawerButton } from "src/app/features/SiteGroup/components/buttons/SiteGroupBatchUpdateDrawerButton";
import { SiteGroupsSearchForm } from "src/app/features/SiteGroup/components/forms/SiteGroupsSearchForm";
import { SiteGroupsTable } from "src/app/features/SiteGroup/components/tables/SiteGroupsTable";
import type { SiteGroupList } from "src/app/features/SiteGroup/types/SiteGroupList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { getAssignedDataGroup } from "../../../../core/router/auth";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

const FORM_COPY_DATA_GROUP_TYPES = new Set(["APAC", "IPASO"]);

export const SiteGroupPage: FC<NoneOwnProps> = () => {
    const table = <SiteGroupsTable />;
    const searchForm = <SiteGroupsSearchForm />;
    const hasAccess = canAccess(ResourceName.SITE_GROUPS, "canRead");

    const formConfigName = getAssignedDataGroup()?.formConfigName?.toUpperCase();
    const copyAction = formConfigName && FORM_COPY_DATA_GROUP_TYPES.has(formConfigName) ? Actions.FORM_COPY : Actions.COPY;

    return (
        <PageLayout name="siteGroups_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.siteGroups" />
                    <ResourceManager<SiteGroupList>
                        useDataGroup
                        dataMapperKey="siteGroupsTableData"
                        resource={ResourceName.SITE_GROUPS}
                        table={table}
                        actions={[Actions.ADD, Actions.DELETE, copyAction, Actions.EXPORT, Actions.IMPORT_DATA]}
                        customActions={[
                            {
                                action: <MoveSiteModal />,
                                permission: "move",
                            },
                            {
                                action: <SiteGroupBatchUpdateDrawerButton />,
                                permission: "batchUpdate",
                            },
                        ]}
                        searchForm={searchForm}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
